var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"my-4 px-4",attrs:{"fluid":""}},[_c('page-title',{staticClass:"mb-3",attrs:{"title":"Repositoriy Browser","subtitle":"Nexus @ SpaceApps"}}),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }